import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './components/CheckoutForm';
import {  useState } from 'react';

// Load Stripe with your publishable key
const stripePromise = loadStripe('pk_live_51RXtPsLbE4j2Km3DOiyeVx4e5JDclIlZ4mfso2dGOwak4mi6zatQM4Wum6E6KwSXOUngVTUs6Va9UUasxgR7rA8400fkC8q8ct'); // Replace with your Stripe publishable key

const TestPay = () => {
  const clientSecret = 'pi_3S9e7dLbE4j2Km3D2RiAgdh1_secret_lG5StrvDVqcAlD3UFxhdNuU3s';


  return (
    <div>
      {clientSecret && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm />
        </Elements>
      )}
    </div>
  );
};

export default TestPay;